exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-file[data-v-7334db64]{margin:7px 8px}.v-card__text[data-v-7334db64]{padding:4px!important}.container[data-v-7334db64]{padding:0!important}.file-error[data-v-7334db64]{color:red;font-weight:700;font-size:10px}", ""]);

// exports
